// English version of the interface texts. Mirrors the structure of fr.js.
const en = {
  documentTitle: "Personality Test",

  common: {
    previous: "Previous",
    next: "Next",
    fillQuestionnaire: "Fill in the Questionnaire",
    initialPrompt: "Initial prompt:",
  },

  home: {
    title: "Dorian Gray",
    projectHeading: "Project overview",
    projectText:
      "The DORIAN GRAY project investigates the link between mild cognitive impairment and cardiovascular disease, in order to develop a strategy for early detection and prevention.",
    appHeading: "Mobile application",
    appText1:
      "The application will offer exercises in the form of innovative games built around a virtual coach, combining cognitive training and physical activity in a personalised and engaging experience.",
    appText2:
      "This approach aims to improve brain and heart health, promote behaviour change and reduce cognitive decline.",
    coachHeading: "Role of the virtual coach",
    coachText1:
      "The virtual coach supports the user day to day, helping them organise, advise and stay motivated while carrying out a variety of exercises.",
    coachText2:
      "It also acts as a teacher, providing information about health and the benefits of exercise; as a companion to talk with; and as support for using the application.",
    coachText3:
      "Versatile by design, it is a central part of the application, guiding the user throughout their journey.",
  },

  etude: {
    title: "Dorian Gray",
    subtitle:"Goal",
    intro1:
      "You will compare **four versions of the DORIAN GRAY digital coach** designed for the application. Our goal is to understand which coaching style is the clearest, most helpful, and the most pleasant to interact with.",
    intro2:
      "There are **no right or wrong answers**. We are interested in **your experience and preferences**, not in your performance.",
    intro3:
    "This activity should take about 1 hour overall. You can take breaks and you can also split the test over multiple sessions (e.g., one session per coach version). ",
    observeHeading: "During the test",
    observe: [
      "You will interact on a web browser with **four different digital coaches**.",
      "You should go through **the same five scenarios with each coach**.",
      "**You must start each conversation**. The coach will only respond after you send a message.",
      "Feel free to use the suggested prompts below or ask the same thing (your task) in your own words.",
      "Try to complete all the scenarios with a coach before moving to the next one."
    ],
    note: "**Important:** Conversations are **ephemeral**. If you leave a coach (using **Go Back**) and return later, the conversation history will be lost and you will start a new chat. Take notes before leaving the chat.",
    scenariosHeading: "Test scenarios",
    scenariosColScenario: "Scenario",
    scenariosColTask: "Your task",
    scenariosColPrompt: "Example opening prompt",
    scenarios: [
      {
        name: "1. Schedule an exercise",
        task: "Ask the coach to help you schedule a gentle exercise session.",
        prompt:
          "\"I'd like to schedule a gentle exercise session for Thursday morning. Can you help me add it to my plan?\"",
      },
      {
        name: "2. Weekly goal",
        task: "Ask the coach to help you set a realistic goal for this week.",
        prompt: "\"Can you help me set a realistic goal for this week?\"",
      },
      {
        name: "3. General health information",
        task: "Ask why regular physical activity is beneficial.",
        prompt:
          "\"Can you explain, in general, why regular physical activity is good for the heart and the brain?\"",
      },
      {
        name: "4. Help with the app",
        task: "Ask the coach for help finding information in the application.",
        prompt:
          "\"I can't find the page with my health information in the app. Can you help me?\"",
      },
      {
        name: "5. Social conversation (if time allows)",
        task: "Get to know the coach and its role in the application.",
        prompt:
          "\"I'd like to get to know you. What can you do in this application?\"",
      },
    ],
  },

  afterCoach: {
    title: "Dorian Gray",
    subtitle: "After each coach",
    subtitle: "Take notes",
    intro:
      "Before moving on to the questionnaire, take a few notes (on paper or by copying them elsewhere), as you will not be able to return to the conversation later.",
    notesHeading: "In particular, note:",
    notes: [
      "Three memorable responses or moments.",
      "What you liked.",
      "What you disliked or found uncomfortable.",
    ],
    gridIntro: "You will evaluate each coach according to the following grid:",
    gridAlt: "Evaluation grid",
    questionnaireNote:
      "You will complete a short questionnaire after each coach and a final questionnaire comparing all four coaches.",
  },

  chatSelection: {
    title: "Virtual coach",
    description: "Please choose an agent to start a conversation",
  },

  questionnaire: {
    title: "Questionnaire",
    description:
      "We now ask you to take your time and rank the virtual coaches in order of preference, from 1 (favourite) to 4. You can go back to the previous step to talk with the virtual coaches again.",
  },

  chat: {
    back: "Back",
    headerSuffix: "Chat",
    welcome: "Hello, I am a conversational agent. How can I help you today?",
    defaultAgentName: "Default Agent",
    placeholder: (name) => `Talk with ${name}...`,
    typing: (name) => `${name} is thinking...`,
    defaultPlaceholder: "Your message...",
    defaultHeaderTitle: "Chat Interface",
    defaultTyping: "The agent is thinking...",
    you: "You",
    connectionError:
      "Sorry, I cannot reach the server at the moment. Please try again later.",
    genericError: (msg) => `Sorry, an error occurred: ${msg}`,
  },

  // Final instruction of the system prompt sent to the model.
  promptTask:
    "TASK: Add the coach's next utterance. Respond in English, one to two sentences, no explanations.",
};

export default en;
